<template>
  <div>
    <side-menu/>
    <loading-screen v-if="loadingScreen"/>
    <section class="container profile-container">
      	<div class="kits">
		    <div class="header"
                v-if="checkCurrentKit(0) && currKit.type !== 'rsl' && currKit.type !== 'tps' && currKit.type !== 'rsk' && currKit.type !== 'pln'">
                <h2 class="title">Olá {{user}},</h2>
                <span class="text">
                    Bem-vindo ao seu painel de Kits Health ID.
                </span>
                <p>
                    Daqui você consegue preencher formulários e acessar os seus resultados clicando em cada Kit e também a sua identidade de saúde no
                    menu localizado à esquerda.
                </p>

		  </div>
        <div class="flex-container" v-if="currKit.type !== 'rsl' && currKit.type !== 'tps' && currKit.type !== 'rsk' && currKit.type !== 'pln'">
			<div class="flex-child">
				<div>
				<button @click="setCurrentKit(null, null)" class="button btn-purple back-button" v-if="checkCurrentKit()">
					Voltar
				</button>
				</div>
			</div>
        </div>
        <div class="no-mobile">
          	<div class="card-header">
          	</div>
            <template v-if="!!results && results.length > 0">
                <template v-for="(result, index) in results">
                    <div v-bind:key="index" v-if="checkCurrentKit(index) && currKit.type !== 'rsl' && currKit.type !== 'tps' && currKit.type !== 'rsk' && currKit.type !== 'pln'">
                        <div class="kit-card" >
                            <div class="row">
                                <div class="kit-image">
                                    <img src="@/assets/images/kits/igg.png" v-if="result.kit_type.tag_type === 'check-up-anticorpos-igg-covid'"/>
                                    <img src="@/assets/images/kits/vacina.png" v-if="result.kit_type.tag_type === 'check-up-anticorpos-vacina-covid'"/>
                                    <img src="@/assets/images/kits/coracao.png" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'"/>
                                    <img src="@/assets/images/kits/longevidade.png" v-if="result.kit_type.tag_type === 'check-up-longevidade-saudavel'"/>
                                    <img src="@/assets/images/kits/cronicos.png" v-if="result.kit_type.tag_type === 'check-up-doencas-cronicas'"/>
                                    <img src="@/assets/images/kits/preventivo.png" v-if="result.kit_type.tag_type === 'check-up-saude-preventiva'"/>
                                </div>
                                <div class="kit-details full">
                                    <span class="kit-name">{{altKitName(getKitType(result.kit_type.tag_type))}} <span class="kit-number">{{ result.number }}</span></span>
                                    <span v-if="result.confirmed_at" class="kit-date">Preenchido em: {{ getConfirmedDate(result.confirmed_at) }}</span>
                                    <span v-if="!result.steps_confirmed" class="kit-info">Você ainda não preencheu o formulário para esse kit.</span>
                                    <span v-if="result.steps_confirmed && result.exam == null" class="kit-info">Aguardando resultados do kit.</span>
                                    <div class="kit-steps full" v-if="result.status == 'refused'">
                                        <div class="step full">
                                            Rejeitada: {{  getInsufficient(result.exam.insufficient) }}
                                        </div>
                                    </div>
                                    <div class="kit-steps" v-if="result.status != 'refused'">
                                        <div class="step" :class="{'active': result.status === 'in_use' && !result.steps_confirmed}">
                                            Questionário Respondido
                                        </div>
                                        <div class="step" :class="{'active': (result.status === 'in_use' || result.status === 'sent_laboratory') && result.steps_confirmed && result.exam === null }">
                                            Análise pelo laboratório
                                        </div>
                                        <div class="step" :class="{'active': result.status === 'finished' && result.steps_confirmed && result.exam === null}">
                                            Resultado Disponível
                                        </div>
                                    </div>
                                </div>
                                <div class="kit-buttons">
                                    <div class="actions" v-if="!result.steps_confirmed">
                                        <button class="button btn-primary" @click.prevent="goToForm(result.number)">Preencher formulário</button>
                                    </div>
                                    <!-- <div class="actions" v-if="result.steps_confirmed && !result.exam && (getShippingType(result.order[0]) == 1 || getShippingType(result.order[0]) == 3)">
                                        <button class="button btn-primary" @click.prevent="openOrientationModal(getShippingType(result.order[0]))">Orientações de Envio da Amostra</button>
                                    </div> -->
                                    <div class="actions" v-if="result.steps_confirmed && !result.exam && !result.schedule && getShippingType(result.order[0]) == 2">
                                        <button class="button btn-primary" @click.prevent="openScheduleModal(result.id, result.number)">Agendar Coleta da minha amostra</button>
                                    </div>
                                    <div class="actions" v-if="result.exam && result.exam.result && result.status != 'refused'">
                                        <button class="button btn-primary" @click.prevent="setCurrentKit(index, 'rsl')">Resultados</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row-reverse" v-if="result.status == 'refused'">

                            </div>
                            <div class="row-reverse" v-if="result.status !== 'refused'">
                                <div class="kit-steps">
                                    <div class="step">
                                        Check-up Ativo
                                    </div>
                                    <div class="step" :class="{'active': result.status === 'in_use' && !result.steps_confirmed}">
                                        Questionário Respondido
                                    </div>
                                    <div class="step" :class="{'active': (result.status === 'in_use' || result.status === 'sent_laboratory') && result.steps_confirmed && result.exam === null }">
                                        Análise pelo laboratório
                                    </div>
                                    <div class="step" :class="{'active': result.status === 'finished' && result.steps_confirmed && result.exam === null}">
                                        Resultado Disponível
                                    </div>
                                </div>
                                <div class="kit-buttons">
                                    <div class="actions" v-if="!result.steps_confirmed">
                                        <button class="button btn-primary" @click.prevent="goToForm(result.number)">Preencher formulário</button>
                                    </div>
                                    <!-- <div class="actions" v-if="result.steps_confirmed && !result.exam && getShippingType(result.order[0]) == 1">
                                        <button class="button btn-primary" @click.prevent="openOrientationModal()">Orientações de Envio da Amostra</button>
                                    </div> -->
                                    <div class="actions" v-if="result.steps_confirmed && !result.exam && !result.schedule && getShippingType(result.order[0]) == 2">
                                        <button class="button btn-primary" @click.prevent="openScheduleModal(result.id, result.number)">Agendar Coleta da minha amostra</button>
                                    </div>
                                    <div class="actions" v-if="result.exam && result.exam.result">
                                        <button class="button btn-primary" @click.prevent="setCurrentKit(index, 'rsl')">Resultados</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
            <template v-else>
                <div v-if="results.lenght == 0">
                    <div class="kit-card" style="color: var(--primary-color);">
                        <div class="kit-image">
                            <img src="@/assets/images/kits/-1.png" />
                        </div>
                        <div class="kit-details no-kit">
                            <span class="kit-name">Você não possui um Check-up cadastrado</span>
                        </div>
                        <div class="kit-buttons">
                            <div class="actions">
                                <button class="button btn-primary" @click.prevent="goToForm('')">Cadastrar novo kit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="kit-box">
        <orientation-modal v-if="orientationModalOpen" @close="orientationModalOpen = false" :shipping-type="orientationModalPartner"/>
        <schedule-modal v-if="scheduleModalOpen"
            @close="scheduleModalOpen = false"
            @updateKit="updateKitSchedule"
            :kit_id="scheduleModalKit"
            :kit_number="scheduleModalKitNumber"
        />
          <kit-results
                @changeView="setInnerView"
                @back="setCurrentKit(null, null)"
                @download="getLink"
                v-bind:result="results[currKit.id]"
                v-if="currKit.type === 'rsl'" />
          <kit-risks
                @changeView="setInnerView"
                @back="setCurrentKit(null, null)"
                @download="getLink"
                v-bind:result="results[currKit.id]"
                v-if="currKit.type === 'rsk'" />
          <kit-plans
                @changeView="setInnerView"
		  		@back="setCurrentKit(null, null)"
                @download="getLink"
			  	v-bind:result="results[currKit.id]"
                v-if="currKit.type === 'pln'" />
          <kit-tips
            	@changeView="setInnerView"
		  		@back="setCurrentKit(null, null)"
                @download="getLink"
			  	v-bind:result="results[currKit.id]"
            	v-if="currKit.type === 'tps'"/>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
    import { GET_DOCUMENT } from '../../services/document'
    import { LIST_KIT } from '../../services/kit'

    import KitResults from '../../components/KitResults/KitResults'
    import KitRisks from '../../components/KitRisks/KitRisks'
    import KitPlans from '../../components/KitPlans/KitPlans'
    import KitTips from '../../components/KitTips/KitTips'

    import OrientationModal from '../../components/OrientationModal/OrientationModal'
    import ScheduleModal from '../../components/ScheduleModal/ScheduleModal'

    import moment from 'moment';

    export default {
        components: {KitResults, KitRisks, KitPlans, KitTips, ScheduleModal, OrientationModal},
        data() {
            return {
                user: null,
                loading: false,
                loadingScreen: false,
                orientationModalPartner: null,
                results: [],
                showResultModal: false,
                resultModalData: null,
                showReturnModal: false,
                returnModalData: null,
                stockPic: "https://www.kindpng.com/picc/m/105-1055656_account-user-profile-avatar-avatar-user-profile-icon.png",
                currKit: {id: null, type: null},
                kitTypes: {},
                orientationModalOpen: false,
                scheduleModalOpen: false,
                scheduleModalKit: null,
                scheduleModalKitNumber: null
            }
        },
        watch: {
          '$route' (to, from){
                if(!to.query.kit){
                    window.scrollTo(0, 0);
                    this.currKit.id = null;
                    this.currKit.type = null;
                }
          }
        },
        methods: {
            checkCurrentKit(id) {
                try {
                    if (id != null) {
                        const empty = !!this.currKit && this.currKit.type == null && this.currKit.id == null;
                        const selected = !!this.currKit && !!this.currKit.type && this.currKit.id === id;

                        return (empty || selected);
                    } else {
                        return !!this.currKit && !!this.currKit.type && this.currKit.id != null;
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            setCurrentKit(id, type) {
                try {
                    window.scrollTo(0, 0);
                    this.currKit.id = id;
                    this.currKit.type = type;
                    this.$router.push(`kits?kit=${id}`)
                } catch (error) {
                    console.log(error);
                }
            },
            setInnerView(view) {
            	this.currKit.type = view;
            },
            getDate(date) {
                date = new Date(date);
                date = (this.aditionalZero(date.getDate())) + "/" + ((this.aditionalZero(date.getMonth() + 1))) + "/" + date.getFullYear();
                return date;
            },
            getInsufficient(insufficient) {
                switch(insufficient) {
                    case 1: return "Amostra insuficiente"
                    case 2: return "Amostra não identificada"
                    case 3: return "Amostra acondicionada de forma inadequada"
                    default: return "N/A"
                }
            },  
            aditionalZero(number) {
                return (number <= 9) ? "0" + number : number;
            },
            getKitType(kitTypeId) {
                try {
                    return this.kitTypes[kitTypeId];
                } catch (error) {
                    console.log(error);
                }
            },
			altKitName(kit) {
				return kit.split("Check-Up ").pop();
			},
            async getReturns() {
                try {
                    this.loadingScreen = true;
                    const response = await LIST_KIT();
                    if (!!response) {
                        this.results = response;
                        const missingForm = [];
                        const missingExam = [];
                        const complete = [];
                        const weird = [];

                        this.results.forEach(result => {
                            if ((result.kit_type_id > 2 && result.steps_answers == null)
                                || (result.kit_type_id <= 2 && result.schedule == null)) {
                                missingForm.push(result);
                            } else if ((result.kit_type_id > 2 && result.steps_answers != null && result.exam == null)
                                || (result.kit_type_id <= 2 && result.schedule != null && result.exam == null)) {
                                missingExam.push(result);
                            } else if ((result.kit_type_id > 2 && result.exam && result.exam.result)
                                || (result.kit_type_id <= 2 && result.exam && result.exam.result)) {
                                complete.push(result);
                            } else {
                                weird.push(result)
                            }
                        });

                        missingForm.sort(this.sortDates);
                        missingExam.sort(this.sortDates);
                        complete.sort(this.sortDates);
                        weird.sort(this.sortDates);

                        this.results = missingForm.concat(missingExam, complete, weird);
                        console.log('>>', this.results);
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loadingScreen = false;
                }
            },
            openResultModal(kit) {
                try {
                    this.resultModalData = {
                        customer: (!!kit.customer && !!kit.customer.name) ? kit.customer.name : '',
                        photo: (!!kit.profile_picture) ? kit.profile_picture : this.stockPic,
                        birthDate: (!!kit.customer && !!kit.customer.birth_date) ? this.getDate(kit.customer.birth_date) : '',
                        gender: (!!kit.customer && !!kit.customer.gender) ? kit.customer.gender : '',
                        kitNumber: (!!kit.number) ? kit.number : '',
                        kitId: (!!kit.id) ? kit.id : '',
                        kitType: (!!kit.kit_type && kit.kit_type.id) ? kit.kit_type.id : '',
                        value: (!!kit.exam && !!kit.exam.result && kit.exam.result.value) ? kit.exam.result.value : '',
                        created_at: (!!kit.order) ? this.getDate(kit.order[0].created_at) : '',
                        finished_at: (!!kit.exam && kit.exam.created_at) ? this.getDate(kit.exam.created_at) : '',
                        resultDocument: (!!kit.exam && !!kit.exam.result_document_id) ? kit.exam.result_document_id : null,
                        labDocument: (!!kit.exam && !!kit.exam.lab_document_id) ? kit.exam.lab_document_id : null,
                    };
                    this.showResultModal = true;
                } catch (error) {
                    console.log(error)
                }
            },
            getShippingType(order) {
              if (!order) return null;
                if(!order.partner_place) return null;
                if(!order.partner_place.partner) return null;
                return order.partner_place.partner.shipping_type;
            },
            openOrientationModal(shippingType = null) {
                this.orientationModalPartner = shippingType;
                this.orientationModalOpen = true;
            },
            openScheduleModal(kitId, kitNumber) {
                this.scheduleModalKit = kitId;
                this.scheduleModalKitNumber = kitNumber;
                this.scheduleModalOpen = true;
            },
            updateKitSchedule(kit_number) {
                const kitIndex = this.results.find((result, x) => { if(result.number == kit_number) return x })
                kitIndex.schedule = true;
            },
            sortDates(a, b) {
                let testA, testB = null;

                if (!!a && !!a.order && !!a.order[0] && !!a.order[0].created_at) {
                    testA = new Date(a.order[0].created_at);
                }

                if (!!b && !!b.order && !!b.order[0] && !!b.order[0].created_at) {
                    testB = new Date(b.order[0].created_at);
                }

                return (!!testA && !!testB) ? testB - testA : 0;
            },
            openReturnModal(kit) {
                try {
                    this.returnModalData = {
                        customer: (!!kit.customer && !!kit.customer.name) ? kit.customer.name : '',
                        kitId: (!!kit.id) ? kit.id : '',
                        kitType: (!!kit.kit_type && !!kit.kit_type.id) ? kit.kit_type.id : '',
                        disease: (!!kit.disease) ? kit.disease : '',
                        annexDocument: (!!kit.exam && !!kit.exam.annex_document_id) ? kit.exam.annex_document_id : null,
                        labDocument: (!!kit.exam && !!kit.exam.lab_document_id) ? kit.exam.lab_document_id : null,
                    };
                    this.showReturnModal = true;
                } catch (error) {
                    console.log(error)
                }
            },
            goToForm(kitNumber) {
                window.location = "/cadastrar-kit?kit_number=" + kitNumber;
            },
            getLink(id, doc) {
                GET_DOCUMENT(id, 3, doc)
                    .then(res => {
                        window.open(res.link, '_blank').focus();
                    });
            },
            getSampleDate(result) {
                let response = '';
                if(!!result.field_answers) {
                    result.field_answers.map(answer => {
                        if(answer.field.title == 'Data e hora da coleta de sangue' || answer.field.title == 'data e hora da coleta de sangue')
                            response = !!answer.response.date ? answer.response.date : answer.response
                    })
                }
                if(response === '' && !!result.schedule) {
                    response = result.schedule.sample_date;
                    const date = moment(response);
                    date.locale('pt-br');
                    response = date.calendar();
                }
                return response;
            },
            getConfirmedDate(value) {
                const date = moment(value);
                date.locale('pt-br');
                return date.format('DD/MM/yyyy HH:mm');
                return date.calendar();
            }
        },
        mounted() {
            let user = window.localStorage.getItem('name');
            this.user = user.split(' ')[0];
            try {
                this.kitTypes['check-up-anticorpos-igg-covid'] = 'Check-Up Anticorpos IgG COVID';
                this.kitTypes['check-up-anticorpos-vacina-covid'] = 'Check-Up Anticorpos Vacina COVID';
                this.kitTypes['check-up-doencas-completo'] = 'Check-Up Completo';
                this.kitTypes['check-up-saude-do-coracao'] = 'Check-Up Saúde do Coração';
                this.kitTypes['check-up-longevidade-saudavel'] = 'Check-Up Longevidade Saudável';
                this.kitTypes['check-up-doencas-cronicas'] = 'Check-Up Doenças Crônicas';
                this.kitTypes['check-up-saude-preventiva'] = 'Check-Up Saúde Preventiva';
                this.kitTypes['exame-litio'] = 'Exame Lítio';

                this.getReturns();
            } catch (error) {
                console.log(error)
            }

        }
    }
</script>

<style scoped>
  @import "kits.scss";
  @import "../Profile/responsive.css";
  @import "./responsive.css";

  .flex-container {
    display: flex;
  }

  .flex-child {
    flex: 1;
  }

  .flex-child:first-child {
    margin-right: 20px;
  }

  .table {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 2px;
  }

  .links {
    background-color: var(--bg-aux-white2);
    border-radius: 100px;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
  }

  .links:hover {
    background-color: #FFFFFF;
  }

  .message {
    font-size: 22px;
    width: 100%;
    color: #FFF;
    font-weight: bold;
  }

  .kit-type-id-1 {
    background-color: #8B1642;
  }

  .kit-type-id-2 {
    background-color: #3D2F8E;
  }

  .kit-type-id-5 {
    background-color: #44B239;
  }

  .kit-type-id-6 {
    background-color: #44192D;
  }

  .kit-type-id-8 {
    background-color: #C4B218;
  }

  .kit-type-id-7 {
    background-color: #D62039;
  }

  td > img {
    max-width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Kits/Kits.vue